const defaultBlocksInCity = [
  {
    index: 1,
    weight: 3,
    block: null,
  },
  {
    index: 2,
    weight: 2,
    block: null,
  },
  {
    index: 3,
    weight: 1,
    block: null,
  },
  {
    index: 4,
    weight: 6,
    block: null,
  },
  {
    index: 5,
    weight: 5,
    block: null,
  },
  {
    index: 6,
    weight: 4,
    block: null,
  },
  {
    index: 7,
    weight: 9,
    block: null,
  },
  {
    index: 8,
    weight: 8,
    block: null,
  },
  {
    index: 9,
    weight: 7,
    block: null,
  },
];

export default defaultBlocksInCity;
